import { INBOX_TYPES } from 'shared/constants/inbox';

export const isAFormMessage = message => message.content_type === 'form';
export const isASubmittedFormMessage = (message = {}) =>
  isAFormMessage(message) && !!message.content_attributes?.submitted_values;

export const MESSAGE_MAX_LENGTH = {
  GENERAL: 10000,
  // The backend does not split Facebook comments, so use the Messenger text
  // limit as a safe value.
  // https://developers.facebook.com/docs/messenger-platform/reference/send-api#request
  FACEBOOK_COMMENT: 2000,
  // https://www.twilio.com/docs/glossary/what-sms-character-limit
  TWILIO_SMS: 320,
  // https://developers.facebook.com/docs/whatsapp/cloud-api/reference/messages#text-object
  WHATSAPP_CLOUD: 4096,
  // https://core.telegram.org/bots/api#sendmessage
  TELEGRAM: 4096,
  // Allegro rejects a longer body outright.
  ALLEGRO: 2000,
  EMAIL: 25000,
  EMAIL_HTML: 1000000,
};

// Facebook and Instagram direct messages have no cap here: the backend
// (FacebookMessageSplittable) sends a long text as several messages.
export const getReplyMaxLength = ({
  isPrivate = false,
  channelType = '',
  isSms = false,
  isFacebookComment = false,
  isEmailHtml = false,
} = {}) => {
  if (isPrivate) return MESSAGE_MAX_LENGTH.GENERAL;
  if (isSms) return MESSAGE_MAX_LENGTH.TWILIO_SMS;

  switch (channelType) {
    case INBOX_TYPES.FB:
      return isFacebookComment
        ? MESSAGE_MAX_LENGTH.FACEBOOK_COMMENT
        : MESSAGE_MAX_LENGTH.GENERAL;
    case INBOX_TYPES.WHATSAPP:
      return MESSAGE_MAX_LENGTH.WHATSAPP_CLOUD;
    case INBOX_TYPES.TELEGRAM:
      return MESSAGE_MAX_LENGTH.TELEGRAM;
    case INBOX_TYPES.ALLEGRO:
      return MESSAGE_MAX_LENGTH.ALLEGRO;
    case INBOX_TYPES.EMAIL:
      return isEmailHtml
        ? MESSAGE_MAX_LENGTH.EMAIL_HTML
        : MESSAGE_MAX_LENGTH.EMAIL;
    default:
      return MESSAGE_MAX_LENGTH.GENERAL;
  }
};
